<div mat-dialog-title class="title-text">{{title}}</div>
<div mat-dialog-content mat-tipography>
    @if (image) {
    <div class="image">
        <img [src]="image" />
    </div>
    }
    <div class="message" [innerHtml]="html"></div>
</div>
<div mat-dialog-actions>
    @if (mode==='YESNO') {
    <button mat-stroked-button (click)="dialogRef.close('no')">
        <div translate>{{buttonNoText}}</div>
    </button>
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close('yes')">
        <span translate>{{buttonYesText}}</span>
    </button>
    } @else if (mode === 'OK') {
    <button mat-flat-button cdkFocusInitial (click)="closeDialog()">
        <span translate>{{buttonOkText}}</span>
    </button>
    } @else if (mode=== 'YESNOCANCEL') {
    <button mat-stroked-button (click)="dialogRef.close('cancel')">
        <div translate>CANCEL</div>
    </button>
    <button mat-stroked-button (click)="dialogRef.close('no')">
        <div translate>{{buttonNoText}}</div>
    </button>
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close('yes')">
        <span translate>{{buttonYesText}}</span>
    </button>

    }


</div>